/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { XMLHttpRequestInstrumentation } from './xhr';
export type {
  XHRCustomAttributeFunction,
  XMLHttpRequestInstrumentationConfig,
} from './xhr';
